import { useQuery } from '@tanstack/react-query';

import { API_CACHE_KEYS } from '@/features/api/constants/cache';
import { useGrapevineOrganizationApi } from '@/features/api/hooks/grapevine-organization/useGrapevineOrganizationApi';
import { isEmptyOrNull } from '@/shared/utils/string';

/**
 * Fetches the statistics-email configuration of a Gebietskörperschaft. If the
 * caller has never saved a config the backend returns the default
 * `{ enabled: true, frequency: 'MONTHLY' }`, so no client-side default logic
 * is required.
 */
export const useGetStatisticsEmailConfig = (organizationId = '') => {
  const api = useGrapevineOrganizationApi();
  return useQuery({
    queryKey: [API_CACHE_KEYS.STATISTICS_EMAIL_CONFIG, organizationId],
    queryFn: () => api.getStatisticsEmailConfig({ organizationId }),
    enabled: !isEmptyOrNull(organizationId)
  });
};
